/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { ApplicationTypesViewModel } from './ApplicationTypesViewModel'; 

export function getAppSettingsOptions(onSuccess?: (result: ApplicationTypesViewModel) => void) {
	return queryOptions({
		queryKey: ['app-settings'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/ui/getapplicationsettings/getappsettings/';
			const resp = await axios.get<ApplicationTypesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}